import React from "react";
import { Table2 } from "lucide-react";

const DashboardTable = ({ tables = [] }) => {
  if (!tables.length) return null;

  return (
    <>
      {tables.map((table, index) => (
        <div
          key={index}
          className="group relative overflow-hidden rounded-2xl bg-white border border-slate-200 shadow-md hover:shadow-xl transition-all duration-500 mb-8 custom-scrollbar"
        >
          {/* Left Accent */}
          <div className="absolute left-0 top-0 h-full w-1 bg-cyan-500 group-hover:w-2 transition-all duration-300" />

          {/* Background Gradient */}
          <div className="absolute inset-0 bg-gradient-to-br from-cyan-50/40 via-white to-indigo-50/30 opacity-0 group-hover:opacity-100 transition-all duration-500" />

          <div className="relative p-6">
            {/* Header */}
            <div className="flex items-center justify-between mb-3">
              <div>
                <h2 className="text-xl font-bold text-slate-800">
                  {table.title}
                </h2>

                <p className="text-sm text-slate-500 mt-1">
                  AI Generated Report
                </p>
              </div>

              <div className="h-12 w-12 rounded-xl bg-cyan-100 flex items-center justify-center group-hover:rotate-12 transition-all duration-500">
                <Table2
                  size={24}
                  className="text-cyan-600"
                />
              </div>
            </div>

            <div className="overflow-x-auto rounded-xl border border-slate-200 scrollbar-thin scrollbar-thumb-slate-300 scrollbar-track-transparent">

              <table className="min-w-full">

                {/* Table Header */}
                <thead className="bg-gradient-to-r from-cyan-500 to-indigo-600">
  <tr>
    {table.columns.map((col, i) => (
      <th
  className="px-6 py-3 text-left text-sm font-semibold uppercase tracking-wide whitespace-nowrap"
  style={{ color: "#fff" }}
>
  {col}
</th>
    ))}
  </tr>
</thead>

                {/* Body */}
                <tbody>

                  {table.rows.map((row, rowIndex) => (
                    <tr
                      key={rowIndex}
                      className={`transition-all duration-300 hover:bg-cyan-50 hover:translate-x-1
                        ${
                          rowIndex % 2 === 0
                            ? "bg-white"
                            : "bg-slate-50"
                        }`}
                    >
                      {row.map((cell, cellIndex) => (
                        <td
                          key={cellIndex}
                          className="px-5 py-3 text-sm text-slate-700 border-b border-slate-100"
                        >
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}

                </tbody>

              </table>

            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default DashboardTable;